import React, { useState, useEffect, useRef } from 'react'

// import Loader from '../../../loader';

import HomeTestimonies01 from './HomeTestimonies_01';
import HomeTestimonies02 from './HomeTestimonies_02';
import HomeTestimonies03 from './HomeTestimonies_03';
import HomeTestimonies04 from './HomeTestimonies_04';

export default function Content(props) {

	const [, set_dados] = useState(null)
	const dados_config = useRef({})
	const template = useRef({})
	const layout = useRef('')
	const content = useRef({})
	const pw = useRef({})

    const [isloading, setLoading] = useState(true);

    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados(dados_config.current = props.dados_config)
            set_dados(template.current = props.dados_config.info.template)
            set_dados(content.current = props.dados_config)
            set_dados(pw.current = props.pag_welcome)
            set_dados(layout.current = props.layout)

            setLoading(false)
        }

    }, [props]);

    return (isloading ?
		null
    :
        <>
            {
            layout.current === 'home-testimonies-01' ?
                <HomeTestimonies01 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-testimonies-02' ?
                <HomeTestimonies02 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-testimonies-03' ?
                <HomeTestimonies03 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-testimonies-04' ?
                <HomeTestimonies04 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
                <HomeTestimonies01 pag_welcome={pw.current} dados_config={dados_config.current} />
            }
        </>
    )
}
